import {
  ComponentType,
  EItemDropBehavior,
  IComponent,
  IComponentDefinition,
  IDisplayItem,
  IDisplayItemComponent
} from "../..";
import { IProject } from "../models/project";

declare let window: any;
declare let require: any;
export class KAgentHelper {
  static filterArray(array: any, keywords: any[]) {
    let filteredArray = [] as any[];
    if (array && array.length > 0) {
      let searchPattern: any = "";
      if (keywords) {
        searchPattern = new RegExp(keywords.map((term: any) => (term ? `(?=.*${term})` : "")).join(""), "i");
      }
      filteredArray = array.filter((c: { name: string }) => {
        if (c && c.name) {
          return c.name.match(searchPattern);
        }
      });
    } else {
      filteredArray = array;
    }
    return filteredArray;
  }

  static getAllChildrenForDI = (rootDI: IDisplayItem): IDisplayItem[] => {
    const DIs: IDisplayItem[] = [];
    const stack: IDisplayItem[] = [rootDI];

    while (stack.length > 0) {
      const currentDI = stack.pop()!;
      DIs.push(currentDI);

      if (currentDI.children && currentDI.children.length > 0) {
        // Use spread operator to create a new array before reversing
        stack.push(...[...currentDI.children].reverse());
      }
    }

    return DIs;
  };

  static findDisplayItemByFriendlyName = (friendlyName: string, DIs: IDisplayItem[]): IDisplayItem | undefined => {
    // Use a stack for iterative depth-first search
    const stack: IDisplayItem[] = [...DIs];

    while (stack.length > 0) {
      const di = stack.pop()!;

      if (di.friendlyName === friendlyName) {
        return di;
      }

      // Add children to stack in reverse order to maintain DFS order
      if (di.children?.length) {
        for (let i = di.children.length - 1; i >= 0; i--) {
          stack.push(di.children[i]);
        }
      }
    }

    return undefined;
  };

  static findDisplayItemByComponentName = (componentName: string, DIs: IDisplayItem[]): IDisplayItem | undefined => {
    // Use a stack for iterative depth-first search
    const stack: IDisplayItem[] = [...DIs];

    while (stack.length > 0) {
      const di = stack.pop()!;

      if (di.item?.name === componentName) {
        return di;
      }

      // Add children to stack in reverse order
      if (di.children?.length) {
        for (let i = di.children.length - 1; i >= 0; i--) {
          stack.push(di.children[i]);
        }
      }
    }

    return undefined;
  };

  static findNextIndexByComponentId = (componentId: string, DIs: IDisplayItem[]): number => {
    let result = 1;
    if (!DIs) {
      return result;
    }
    DIs.forEach((di: IDisplayItem) => {
      if (di.item.id === componentId) {
        result++;
      }
      const DIChildren = KAgentHelper.getAllChildrenForDI(di);
      DIChildren.forEach((childDi) => {
        if (childDi.item.id === componentId) {
          result++;
        }
      });
    });
    return result;
  };

  static findDiByFriendlyName(friendlyName: string, displayItems: IDisplayItem[]): boolean {
    const isFriendNameExist = KAgentHelper.findDisplayItemByFriendlyName(friendlyName, displayItems);
    if (isFriendNameExist) {
      return true;
    }
    return false;
  }

  static createNewFriendlyName = (componentName: string, componentId: string, DIs: IDisplayItem[]) => {
    let index = KAgentHelper.findNextIndexByComponentId(componentId, DIs);
    let isFriendNameExist = this.findDiByFriendlyName(componentName + index, DIs);
    while (isFriendNameExist) {
      isFriendNameExist = this.findDiByFriendlyName(componentName + (index + 1), DIs);
      index++;
    }
    return componentName + index;
  };

  static findComponentById = (id: string, components: IComponent[]): IComponent | undefined => {
    if (components) {
      let component = {} as IComponent | undefined;
      component = components.find((s) => s.id === id);
      if (!component) {
        const htmlComponentList: IComponent[] = require("../../json/html-components.json");
        component = htmlComponentList.find((s) => s.id === id);
      }
      return component;
    }
  };

  static getComponentDefinitionInner = (
    diComponent: IDisplayItemComponent,
    components: IComponent[]
  ): IComponentDefinition | undefined => {
    if (diComponent && components) {
      const component: IComponent | undefined = KAgentHelper.findComponentById(diComponent.id, components);
      if (component) {
        const result: IComponentDefinition = {
          addChildText: component.addChildText,
          blockStyle: component.blockStyle,
          componentSetId: component.componentSetId,
          componentType: component.componentType,
          data: component.data,
          dropAreaText: component.dropAreaText,
          id: component.id,
          isItChildItem: component.isItChildItem,
          hasValidate: component.hasValidate,
          isItNavigationComponent: component.isItNavigationComponent,
          isItHiddenFromComponentList: component.isItHiddenFromComponentList,
          appSupportType: component.appSupportType,
          isDeprecated: component.isDeprecated,
          isRenamingDisabled: component.isRenamingDisabled,
          wrapWithFormItem: component.wrapWithFormItem,
          methods: component.methods,
          name: component.name,
          removeChildText: component.removeChildText,
          tagName: component.tagName,
          children: component.children,
          childrenInfo: component.childrenInfo,
          childrenNames: component.childrenNames,
          isHtml: component.isHtml,
          selectedChildId: component.selectedChildId,
          titleAttributeName: component.titleAttributeName,
          componentCategoryName: component.componentCategoryName,
          inVisibleStyles: component.inVisibleStyles,
          isReportDesignComponent: component.isReportDesignComponent,
          dragDropAreaText: component.dragDropAreaText,
          isDataRepeater: component.isDataRepeater,
          quickProps: component.quickProps
        };
        return result;
      }
    }
  };

  static getComponentDefinition = (
    diComponent: IDisplayItemComponent,
    project: IProject
  ): IComponentDefinition | undefined => {
    if (project && project.componentSetObj && project.componentSetObj.components) {
      const result: IComponentDefinition | undefined = KAgentHelper.getComponentDefinitionInner(
        diComponent,
        project.componentSetObj.components
      );
      return result;
    }
  };

  static itemDropBehavior = (source: IComponent, target: IComponent): EItemDropBehavior => {
    const isTargetDroppableContainer =
      target.componentType === ComponentType.abstractContainer ||
      target.componentType === ComponentType.container ||
      target.componentType === ComponentType.responsiveColumn ||
      target.componentType === ComponentType.fixedHeader ||
      target.componentType == ComponentType.fixedFooter ||
      target.componentType == ComponentType.pageHeader ||
      target.componentType == ComponentType.pageFooter ||
      target.componentType == ComponentType.layoutLeft ||
      target.componentType == ComponentType.layoutRight ||
      target.componentType == ComponentType.layoutHeader ||
      target.componentType == ComponentType.layoutFooter;

    switch (source.componentType) {
      case ComponentType.simple:
      case ComponentType.itemContainer:
      case ComponentType.container:
        return isTargetDroppableContainer ? EItemDropBehavior.asLastChildItem : EItemDropBehavior.afterItem;
      case ComponentType.responsiveColumn:
        return target.componentType === ComponentType.responsiveRow
          ? EItemDropBehavior.asLastChildItem
          : EItemDropBehavior.cantDrop;
      case ComponentType.fixedHeader:
        return EItemDropBehavior.asFixedHeader;
      case ComponentType.fixedFooter:
        return EItemDropBehavior.asFixedFooter;
      case ComponentType.pageHeader:
        return EItemDropBehavior.asPageHeader;
      case ComponentType.pageFooter:
        return EItemDropBehavior.asPageFooter;
      case ComponentType.layoutHeader:
        return EItemDropBehavior.asLayoutHeader;
      case ComponentType.layoutFooter:
        return EItemDropBehavior.asLayoutFooter;
      case ComponentType.layoutLeft:
        return EItemDropBehavior.asLayoutLeft;
      case ComponentType.layoutRight:
        return EItemDropBehavior.asLayoutRight;
      case ComponentType.responsiveRow:
        return isTargetDroppableContainer
          ? EItemDropBehavior.asLastChildItem
          : source.componentType === ComponentType.responsiveRow
            ? EItemDropBehavior.afterItem
            : EItemDropBehavior.cantDrop;
      default:
        break;
    }

    return EItemDropBehavior.cantDrop;
  };

  static findRelatedNavigationDisplayItems(
    di: IDisplayItem,
    displayItems: IDisplayItem[],
    relatedItems: IDisplayItem[]
  ): void {
    // Use a queue for breadth-first search
    const queue: IDisplayItem[] = [di];
    const seen = new Set<number>();

    while (queue.length > 0) {
      const current = queue.shift()!;

      if (seen.has(current.id)) {
        continue;
      }
      seen.add(current.id);

      // Process events and actions
      current.item?.events?.forEach((event) => {
        event.actions?.forEach((action) => {
          if (action.label === "NAVIGATE") {
            const navKuikaIdParam = action.parameters.find((x) => x.name === "navigationKuikaId");
            if (navKuikaIdParam?.symbol?.fixedValue) {
              const navDI = this.findDisplayItemById(navKuikaIdParam.symbol.fixedValue, displayItems);
              if (navDI && !relatedItems.some((x) => x.id === navDI.id)) {
                relatedItems.push(navDI);
                queue.push(navDI); // Add to queue to process its navigation actions
              }
            }
          }
        });
      });

      // Add children to queue
      if (current.children?.length) {
        queue.push(...current.children);
      }
    }
  }

  static findDisplayItemById(id: number | string, displayItems: IDisplayItem[]): IDisplayItem | undefined {
    // Use Map for O(1) lookup if we have many items
    const idMap = new Map<number | string, IDisplayItem>();
    const stack: IDisplayItem[] = [...displayItems];

    // Build map first
    while (stack.length > 0) {
      const di = stack.pop()!;
      idMap.set(di.id, di);

      if (di.children?.length) {
        stack.push(...di.children);
      }
    }

    return idMap.get(id);
  }

  static getAllChildrenDisplayItems(di: IDisplayItem): IDisplayItem[] {
    const result: IDisplayItem[] = [];
    const stack: IDisplayItem[] = [di];

    while (stack.length > 0) {
      const current = stack.pop()!;

      if (current.children?.length) {
        result.push(...current.children);
        stack.push(...current.children);
      }
    }

    return result;
  }
}
